<template>
    <div class="layout mod-basic">
        <Toolbar v-if="isLoggedIn" @logout="$parent.logout"/>

        <div class="row main-row">
            <div class="col-md-2 main-menu full-page" v-if="showSidebar">
                <SidebarMenu :project="project"/>
            </div>

            <div class="col-md-10 page-content"
                 :class="showSidebar ? 'col-md-10 sidebarVisible' : 'col-md-12 sidebarHidden'">
                <h1 class="page-header title-container">
                    <!--
                    <a href="javascript:void(0);" :title="showSidebar ? 'Hide menu' : 'Show menu'" class="sidebarToggle" @click="showSidebar = !showSidebar">
                        <b-icon-arrow-right-circle v-if="!showSidebar"></b-icon-arrow-right-circle>
                        <b-icon-arrow-left-circle v-else></b-icon-arrow-left-circle>
                    </a>
                    -->

                    {{ $route.meta.title }}
                </h1>

                <div class="page-wrapper">
                    <router-view/>
                </div>
            </div>
        </div>


        <b-modal
            id="confirm-publish-modal"
            :title="project.published_at ? 'Unpublish project' : 'Publish project'"
            :ok-title="project.published_at ? 'Unpublish' : 'Publish'"
            size="md"
            centered
            @show="isPublishModalVisible = true"
            @hidden="isPublishModalVisible = false"
            @ok="project.published_at ? unpublish() : publish()">
            <p>
                Are you sure you want to {{ project.published_at ? 'unpublish' : 'publish' }} the project?
            </p>
        </b-modal>

        <b-modal
            id="project-status-change-modal"
            centered
            size="md"
            :title="project.published_at ? 'Project published' : 'Project unpublished'"
            ok-title="Close"
            ok-only>
            <p>
                Project was <span v-text="project.published_at ? 'published' : 'unpublished'"/> successfully.
            </p>
        </b-modal>

        <b-modal
            id="remove-project-modal"
            ref="remove-project-modal"
            title="Delete project"
            ok-title="Delete"
            :ok-disabled="deleteModalInput.toLowerCase() !== 'delete'"
            size="md"
            centered
            @ok="onRemoveProject">
            <p>Are you sure you want to delete this project?</p>
            <p>Confirm deleting the project by typing "delete" below:</p>

            <b-input v-model="deleteModalInput" placeholder="Type 'DELETE' here" autofocus/>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios';
import Toolbar from '@components/common/Toolbar';
import SidebarMenu from "@components/common/SidebarMenu";
import EventBus from '@js/eventBus';

export default {
    components: {
        Toolbar, SidebarMenu
    },
    data() {
        return {
            isPublishModalVisible: false,
            id: this.$route.params.id,
            project: {},
            showSidebar: true,
            deleteModalInput: ''
        }
    },
    computed: {
        isLoggedIn: function () {
            return this.$store.getters.isLoggedIn
        }
        //...mapState(['project'])
    },
    mounted() {
        if (this.$store.state.project.id === null) {
            this.$store.state.project.id = localStorage.project_id;
            this.$store.state.company.id = localStorage.company_id;

            if (this.$store.state.companies.length === 0) {
                this.$store.dispatch('loadCompanies');
            }

            this.$store.dispatch('loadProject', localStorage.project_id).then(project => {
                if (project && project.id) {
                    this.project = project;
                    EventBus.$emit('project-loaded', project);
                }
            }).catch(err => {
                console.log('err', err);
            });
        }
        this.project = this.$store.state.project;
    },
    methods: {
        hideDeleteModal() {
            this.$refs['remove-project-modal'].hide()
        },
        publish() {
            let token = this.$store.state.token;

            axios({
                url: this.$store.getters.apiBase + '/projects/' + this.project.id,
                method: 'PUT',
                headers: {"Authorization": "Bearer " + token},
                data: {
                    published_at: true
                }
            })
                .then(response => {
                    this.$store.state.project.published_at = response.data.data.published_at;
                    this.$bvModal.show('project-status-change-modal');

                })
                .catch(error => {
                });
        },

        unpublish() {
            let token = this.$store.state.token;

            axios({
                url: this.$store.getters.apiBase + '/projects/' + this.project.id,
                method: 'PUT',
                headers: {"Authorization": "Bearer " + token},
                data: {
                    published_at: null
                }
            })
                .then(response => {
                    this.$store.state.project.published_at = null;
                    this.$bvModal.show('project-status-change-modal');
                })
                .catch(error => {
                });
        },

        onRemoveProject() {
            let token = this.$store.state.token;

            if (this.files) {
                let index = this.activeFileIndex;
                let file = this.files[index];
                this.activeFileIndex = null;

                file.hidden = true;
                this.$set(this.files, index, file);
            }

            axios({
                url: this.$store.getters.apiBase + '/projects/' + this.project.id,
                method: 'DELETE',
                headers: {"Authorization": "Bearer " + token}
            });

            this.$router.push({name: 'projects-index'});
        },
    },
    watch: {
        isPublishModalVisible(value) {
            if (value) {
                this.$bvModal.show('confirm-publish-modal');
            }
        }
    }
}
</script>
